import { Icon } from 'bsa-ui';
import cn from 'classnames';
import React from 'react';
import styles from './LoadingSpinnerInfo.styles.less';
import Spin from '@modules/shared/components/Spin';
import S from '@shared/components/S';

const antIcon = <Icon type="loading" spin style={{ fontSize: 16 }} />;

export function LoadingSpinnerInfo(props: {
  label: React.ReactNode;
  isLoading: boolean;
}) {
  return (
    <div
      className={cn(styles.fetchingIndicator, {
        [styles.isLoading]: props.isLoading,
      })}
    >
      <Spin indicator={antIcon} />
      <S size="5" semibold>
        {props.label}
      </S>
    </div>
  );
}
